/**
 * Detect if the current browser is an in-app WebView (e.g., LINE, Facebook, Instagram).
 * Google blocks OAuth in these environments with "403: disallowed_useragent".
 */

const inAppBrowserPatterns = [
  'line/', // LINE (case-insensitive: Line/, LINE/, line/)
  'fban', // Facebook
  'fbav', // Facebook
  'instagram', // Instagram
  'twitter', // Twitter/X
  'micromessenger', // WeChat
  'kakaotalk', // KakaoTalk
];

export const isInAppBrowser = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();

  return inAppBrowserPatterns.some((pattern) => userAgent.includes(pattern));
};
